import * as App from '@/types/app';
import * as Database from '@/types/database';
import { useFirestore } from '@/services';
import { mapAppVendorToDatabaseVendor, mapDatabaseVendorToAppVendor } from '@/utils';
import { defineFirebaseCollectionStoreModule } from './base-module';

const { useVendorOperators } = useFirestore();
export const vendorsModule = defineFirebaseCollectionStoreModule<App.Vendor, Database.Vendor>(useVendorOperators, {
  databaseModelToAppModel: mapDatabaseVendorToAppVendor,
  appModelToDatabaseModel: mapAppVendorToDatabaseVendor
});
